// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Details-module__container--dJlfB{overflow:hidden;height:100%;display:flex;flex-direction:column}", "",{"version":3,"sources":["webpack://./app/containers/VerticalPage/nft/Details/Details.module.scss"],"names":[],"mappings":"AAAA,kCACI,eAAA,CACA,WAAA,CACA,YAAA,CACA,qBAAA","sourcesContent":[".container {\n    overflow: hidden;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "Details-module__container--dJlfB"
};
export default ___CSS_LOADER_EXPORT___;
